import { ReactNode } from 'react';

import { ReadonlyText } from './ReadonlyText';

type ReadonlyUnit = {
  prefix?: string;
  suffix?: string;
};

type ReadonlyUnitEntity = {
  value: unknown;
  [key: string]: unknown;
};

// Enso's readonly text drops a field's addonBefore/addonAfter, and on an amount or a percentage that addon is the unit.
export const renderReadonlyWithUnit =
  ({ prefix = '', suffix = '' }: ReadonlyUnit) =>
  (_dom: ReactNode | null, { value }: ReadonlyUnitEntity): ReactNode =>
    value === null || value === undefined || value === '' ? (
      <ReadonlyText value={undefined} />
    ) : (
      <ReadonlyText value={`${prefix}${String(value)}${suffix}`} />
    );
